
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/infrastructure/township",
      function () {
        return require("private-next-pages/project/infrastructure/township.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/infrastructure/township"])
      });
    }
  